import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";
import { loadBMap } from "@/common/map";
import { cityjosn } from '@/utils/city'
Vue.use(Vuex);
Vue.prototype.$store = store;

const store = new Vuex.Store({
  state: {
    lang: "En",
    baseSrc: "/static/image/",
    footToHome: 0,
    scrollTop: 0,
    clientHeight: 0,
    innerWidth: 0,
    forumTypes: [],
    searchListBoolean: false,
    successNum: 0,
    banners: {},
    openAd: false,
    labels: [],
    //

    headersTitle: "首页",
    token: null,
    tenantId: null,
    userInfo: null,
    enterInfo: null,
    download: 0,
    areaList: cityjosn,
    exaState: true,
    unreadCount:false,
    point: {
      province: "",
      city: "",
      latitude: "",
      longitude: "",
    },

    clientHeight: "auto"
  },
  mutations: {
    initClientHeight: (state, data) => {
      state.clientHeight = data;
    },

    changePoint(state, point) {
      state.point.province = point.province;
      state.point.city = point.city;
      state.point.latitude = point.latitude;
      state.point.longitude = point.longitude;
    },
    //消息状态
    SET_UNREAD: (state, count) =>{
      state.unreadCount = count
    },
    //路由状态
    SET_exaState: (state, exaState) => {
      console.log(exaState,9999)
      state.exaState = exaState
    },
    // 设置头部headerTitle
    SET_HEADERSTITLE: (state, data) => {
      state.headersTitle = data;
    },
    //下载次数
    SET_DOWNLOAD: (state, download) => {
      state.download = download
    },
    // token
    SET_TOKEN: (state, token) => {
      state.token = token;
      localStorage.setItem("token", token);
    },
    REMOVE_TOKEN: state => {
      state.token = null;
      localStorage.removeItem("token");
    },

    // tenantId
    SET_TENANTID: (state, id) => {
      console.log(id)
      state.tenantId = id;
      localStorage.setItem("tenantId", id);
    },
    REMOVE_TENANTID: state => {
      state.tenantId = null;
      localStorage.removeItem("tenantId");
    },

    // userInfo
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
      localStorage.setItem("userInfo", data);
    },
    REMOVE_USERINFO: state => {
      state.userInfo = null;
      localStorage.removeItem("userInfo");
    },

    // enterInfo
    SET_ENTERINFO: (state, data) => {
      state.enterInfo = data;
      localStorage.setItem("enterInfo", data);
    },
    REMOVE_ENTERINFO: state => {
      state.enterInfo = null;
      localStorage.removeItem("enterInfo");
    },

    changePoint(state, point) {
      state.point.province = point.province;
      state.point.city = point.city;
      state.point.latitude = point.latitude;
      state.point.longitude = point.longitude;
    },
    //
    setLang(state, v) {
      state.lang = v;
    },
    setFootToHome(state) {
      state.footToHome += 1;
    },
    setTop(state, v) {
      state.scrollTop = v;
    },
    setHeight(state, v) {
      state.clientHeight = v;
    },
    setWidth(state, v) {
      state.innerWidth = v;
    },
    setForumType(state, v) {
      state.forumTypes = v;
    },
    setSearchList(state, v) {
      state.searchListBoolean = v;
    },
    setSuccessNum(state) {
      state.successNum++;
    },
    clearSuccessNum(state) {
      state.successNum = 0;
    },
    setBanners(state, v) {
      state.banners = v;
    },
    setOpenAd(state, v) {
      state.openAd = v;
    },
    setLabels(state, v) {
      state.labels = v;
    }
  },
  actions: {
    
    // 退出登录
    outLoginClick({ commit }) {
      commit("REMOVE_TOKEN");
      // commit("REMOVE_TENANTID");
      commit("REMOVE_USERINFO");
      let that = Vue.prototype
      let promise = that.tim.logout();
      promise.then(function(imResponse) {
              console.log(imResponse.data); // 登出成功
      }).catch(function(imError) {
              console.warn('logout error:', imError);
      });
      commit("REMOVE_ENTERINFO");
    },
    // 如有缓存直接赋值vuex 不去请求接口
    loadLocal({ commit }) {
      const token = window.localStorage.getItem("token");
      if (token) {
        commit("SET_TOKEN", token);
      }
      const tenantId = window.localStorage.getItem("tenantId");
      if (tenantId) {
        commit("SET_TENANTID", tenantId);
      }
      const userInfo = window.localStorage.getItem("userInfo");
      if (userInfo) {
        commit("SET_USERINFO", userInfo);
      }
      const enterInfo = window.localStorage.getItem("enterInfo");
      if (enterInfo) {
        commit("SET_ENTERINFO", enterInfo);
      }
      const point = window.localStorage.getItem("point");
      if (point) {
        commit("changePoint", JSON.parse(point));
      }
      
    },
    getArea({ commit }) {
      let that = this;
      //定义回调函数
      window.initBaiduMapScript = () => {
        that.BMap = window.BMap;
        var geolocation = new that.BMap.Geolocation();
        geolocation.getCurrentPosition(
          function (r) {
            if (this.getStatus() == 0) {
              let pointInfo = {
                province: r.address.province,
                city: r.address.city,
                latitude: r.latitude,
                longitude: r.longitude
              };
              //成功获取位置信息
              commit("changePoint", pointInfo);
              window.localStorage.setItem("point", JSON.stringify(pointInfo));
            } else {
              //无法获取到位置信息
              Message.error('无法获取到位置信息');
            }
          },
          {
            enableHighAccuracy: true
          }
        );
      };
      //调用脚本获取位置信息
      loadBMap("initBaiduMapScript");
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js